function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

export function enhanceAccessibility(text: string, englishWords: string[]): string {
  const wordRegex = new RegExp(`\\b(${englishWords.join('|')})\\b`, 'gi');
  const timeRegex = /\b(\d{1,2})h(\d{2})?\b/g;

  let result = '';

  const matches: { start: number; end: number; replacement: string }[] = [];

  text.replace(wordRegex, (match, _, offset) => {
    matches.push({
      start: offset,
      end: offset + match.length,
      replacement: `<span lang="en">${escapeHtml(match)}</span>`,
    });
    return match;
  });

  text.replace(timeRegex, (match, h, m, offset) => {
    const hours = parseInt(h, 10);
    const minutes = m ? parseInt(m, 10) : null;

    const numberToWords = (num: number): string => {
      const units = [
        'zero', 'uma', 'duas', 'três', 'quatro', 'cinco', 'seis', 'sete',
        'oito', 'nove', 'dez', 'onze', 'doze', 'treze', 'quatorze', 'quinze',
        'dezesseis', 'dezessete', 'dezoito', 'dezenove'
      ];
      const tens = ['', '', 'vinte', 'trinta', 'quarenta', 'cinquenta'];

      if (num < 20) return units[num];
      const t = Math.floor(num / 10);
      const u = num % 10;
      return u === 0 ? tens[t] : `${tens[t]} e ${units[u]}`;
    };

    const hText = numberToWords(hours) + (hours === 1 ? ' hora' : ' horas');
    const mText = minutes !== null && minutes !== 0 ? ' e ' + numberToWords(minutes) : '';
    const label = hText + mText;

    matches.push({
      start: offset,
      end: offset + match.length,
      replacement: `<time aria-label="${label}">${match}</time>`,
    });
    return match;
  });

  matches.sort((a, b) => a.start - b.start);

  let pointer = 0;
  for (const { start, end, replacement } of matches) {
    if (start >= pointer) {
      result += text.slice(pointer, start);
      result += replacement;
      pointer = end;
    }
  }
  result += text.slice(pointer);

  return result;
}
